angular.module('mercury.modules.time.staff')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Time.StaffList', {
    url: '/staff/list',
    controller: 'TimeStaffListCtrl',
    templateUrl: 'modules/time/staff/list.tpl.html',
    params: {'updatedStaff': null}
  });

  $stateProvider.state('Time.StaffAdd', {
    url: '/staff/add?:posIdentifier',
    controller: 'TimeStaffEditCtrl',
    templateUrl: 'modules/time/staff/edit.tpl.html',
    data: {
      menuLinkState: 'Time.StaffList'
    },
    resolve: {
      PreviousState: ['$state', function($state) {
        return {
          name: $state.current.name,
          params: angular.copy($state.params)
        };
      }]
    }
  });

  $stateProvider.state('Time.StaffEdit', {
    url: '/staff/edit/:id?from',
    controller: 'TimeStaffEditCtrl',
    templateUrl: 'modules/time/staff/edit.tpl.html',
    data: {
      menuLinkState: 'Time.StaffList'
    },
    resolve: {
      PreviousState: ['$state', function($state) {
        return {
          name: $state.current.name,
          params: angular.copy($state.params)
        };
      }]
    }
  });

  // React routes below
  $stateProvider.state('Time.WorkforceStaffMembers', {
    url: '/workforce/staff-members',
    controller: 'ReactCtrl'
  });

  $stateProvider.state('Time.WorkforceEditStaffMember', {
    url: '/workforce/staff-members/:staffMemberId?tab',
    controller: 'ReactCtrl',
    data: {
      menuLinkState: 'Time.WorkforceStaffMembers'
    }
  });

  $stateProvider.state('Time.WorkforceAddStaffMember', {
    url: '/workforce/staff-members/add?firstName&lastName&posIdentifier&hourlyRate&roleIdentifier&roleName',
    controller: 'ReactCtrl',
    data: {
      menuLinkState: 'Time.WorkforceStaffMembers'
    }
  });

  $stateProvider.state('Time.WorkforceApprovals', {
    url: '/workforce/approvals',
    controller: 'ReactCtrl'
  });

  $stateProvider.state('Time.WorkforceManageRequest', {
    url: '/workforce/approvals/:type/:requestId',
    controller: 'ReactCtrl'
  });
}]);
